import React from 'react';
import axios from 'axios';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import Table from "../../components/Table/index";

class UserList extends React.Component {
    constructor(props) {
        super(props);
        moment.locale('cs');

        const tooltipPreview = (
            <Tooltip id="tooltip-preview">Náhled</Tooltip>
        );

        const columns = [{
            Header: 'Jméno',
            accessor: 'firstname',
        }, {
            Header: 'Příjmení',
            accessor: 'surname',
        }, {
            Header: 'Přezdívka',
            accessor: 'nickname',
        },{
            Header: 'Email',
            accessor: 'email',
        }, {
            Header: 'Telefonní číslo',
            accessor: 'phoneNumber',
        },{
            Header: 'Věk',
            accessor: 'age',
        }, {
            Header: 'Registrace',
            accessor: 'registrationDate',
        },{
            Header: 'Možnosti',
            style: {padding: '0px'},
            filterable: false,
            Cell: row => (
                <div className="row-menu">
                    <OverlayTrigger placement="top" overlay={tooltipPreview}>
                        <Link to={`/users/preview/${row.original.id}`}>
                            <FontAwesome
                              name="eye"
                              className="cursor-p"
                            />
                        </Link>
                    </OverlayTrigger>
                </div>
            )
        }];

        const tableOptions = {
            showPagination: true,
            showPageSizeOptions: true,
            showPageJump: true,
            collapseOnSortingChange: true,
            collapseOnPageChange: true,
            collapseOnDataChange: true,
            freezeWhenExpanded: false,
            filterable: true,
            sortable: true,
            resizable: true,
            defaultPageSize: 10
        };

        this.state = {
            users: [],
            columns: columns,
            tableOptions: tableOptions
        };
    }

    componentDidMount() {
        this.getUsers();
    };

    getUsers() {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.get(this.props.api.users, config)
        .then((result) => {
            if (!this._calledComponentWillUnmount) {
                result.data.forEach(function (elem) {
                    if(elem['registrationDate']) elem['registrationDate'] = moment(elem['registrationDate']).format('LLL');
                    return elem;
                });
                this.setState({
                    users: result.data.filter((e) => e.role === 'user'),
                    tableOptions: {
                        ...this.state.tableOptions,
                        loading: false
                    }
                });
            }
        }).catch(function (error) {
            console.error('Axios error: ', error);
        });
    }

    render() {
        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Seznam uživatelů</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    <Table
                        columns={this.state.columns}
                        data={this.state.users}
                        tableOptions={this.state.tableOptions}
                        defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(UserList);



/** WEBPACK FOOTER **
 ** ./src/containers/Users/UserList.js
 **/